import React, { useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import PrimaryButton from "../../commonElements/buttons/primaryButton.jsx";
import CompanyLogo from "../../../assets/images/MindoxTechno.png";

import "./navBar.css";

const NavigationBar = () => {
  const collapseRef = useRef();
  const navigate = useNavigate();

  const handleCollapse = () => {
    const el = collapseRef.current;
    if (el?.classList.contains("show")) {
      // Add collapse animation
      el.classList.remove("show");
      el.classList.add("collapsing");
      el.style.height = el.scrollHeight + "px";

      requestAnimationFrame(() => {
        el.style.height = "0px";
      });

      el.addEventListener(
        "transitionend",
        () => {
          el.classList.remove("collapsing");
          el.style.height = "";
          el.classList.add("collapse");
        },
        { once: true }
      );
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleCollapse();
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-root-element shadow-sm rounded-4">
      <div className="container nav-container px-0">
        <Link className="m-0" to="/" onClick={() => handleNavigate("/")}>
          <img
            className="d-inline-block align-text-center me-5"
            src={CompanyLogo}
            style={{ width: "auto", height: "4rem" }}
            alt="MindOx Techno Logo"
          />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse transition-height"
          id="navbarNavDropdown"
          ref={collapseRef}
        >
          <ul className="navbar-nav ms-auto">
            {/* Products */}
            <li className="nav-item px-2 dropdown nav-list-item">
              <button
                className="nav-link dropdown-toggle d-flex align-items-center"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: "#5c5c5e" }}
              >
                Products
              </button>
              <ul className="dropdown-menu dropper">
                <div className="dropper-wrap">
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/platform-solutions" onClick={handleCollapse}>
                      Platform Solutions
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/process-equipment" onClick={handleCollapse}>
                      Process Equipment
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/advance-materials/eco-mask" onClick={handleCollapse}>
                      Advanced Materials
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/automation-solutions" onClick={handleCollapse}>
                      Automation Solutions
                    </NavLink>
                  </li>
                </div>
              </ul>
            </li>

            {/* Services */}
            <li className="nav-item px-2 dropdown nav-list-item">
              <button
                className="nav-link dropdown-toggle d-flex align-items-center"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: "#5c5c5e" }}
              >
                Services
              </button>
              <ul className="dropdown-menu dropper">
                <div className="dropper-wrap">
                  <li className="dropdown-item nav-sub-list-item disabled-item">
                    <NavLink
                      to="/customized-software-solution"
                      onClick={handleCollapse}
                    >
                      Customized Software Solutions
                    </NavLink>
                    <span className="badge rounded-pill text-bg-warning ms-2">
                      Coming Soon
                    </span>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink
                      to="/engineering-resources"
                      onClick={handleCollapse}
                    >
                      Global Capability Center
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item disabled-item">
                    <NavLink
                      to="/manufacturing-sub-contract"
                      onClick={handleCollapse}
                    >
                      Manufacturing Sub-contract
                    </NavLink>
                    <span className="badge rounded-pill text-bg-warning ms-2">
                      Coming Soon
                    </span>
                  </li>
                  <li className="dropdown-item nav-sub-list-item disabled-item">
                    <NavLink to="/available-soon" onClick={handleCollapse}>
                      Legacy Tool Conversion
                    </NavLink>
                    <span className="badge rounded-pill text-bg-warning ms-2">
                      Coming Soon
                    </span>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/post-warranty-services" onClick={handleCollapse}>
                      Post Warranty Service Packages
                    </NavLink>
                  </li>
                </div>
              </ul>
            </li>

            {/* Resources */}
            <li className="nav-item px-2 dropdown nav-list-item">
              <button
                className="nav-link dropdown-toggle d-flex align-items-center position-relative"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: "#5c5c5e" }}
              >
                Resources
                <span className="ms-4 mb-2 position-absolute top-0 start-50 translate-middle-x badge rounded-pill bg-danger">
                  New
                </span>
              </button>

              <ul className="dropdown-menu dropper">
                <div className="dropper-wrap">
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/press-releases" onClick={handleCollapse}>
                      Press Releases
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/product-launches" onClick={handleCollapse}>
                      Product Launches
                      <span
                        className="top-0 start-0 translate-middle mx-2 p-1 bg-danger border border-light rounded-circle"
                        style={{ fontSize: "1px", verticalAlign: "super" }}
                      ></span>
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item disabled-item d-flex justify-content-between align-items-center">
                    <NavLink to="/knowledge-hub" onClick={handleCollapse}>
                      Knowledge Hub
                    </NavLink>
                    <span className="badge rounded-pill text-bg-warning ms-2">
                      Coming Soon
                    </span>
                  </li>
                  <li className="dropdown-item nav-sub-list-item disabled-item">
                    <NavLink to="/available-soon" onClick={handleCollapse}>
                      Training Center
                    </NavLink>
                    <span className="badge rounded-pill text-bg-warning ms-2">
                      Coming Soon
                    </span>
                  </li>
                </div>
              </ul>

            </li>

            {/* Life at MindOx */}
            <li className="nav-item px-2 dropdown nav-list-item">
              <button
                className="nav-link dropdown-toggle d-flex align-items-center"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: "#5c5c5e" }}
              >
                Life at MindOx
              </button>
              <ul className="dropdown-menu dropper">
                <div className="dropper-wrap">
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/about-us" onClick={handleCollapse}>
                      About Us
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/life-at-mindox/leadership-team" onClick={handleCollapse}>
                      Leadership Team
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/life-at-mindox/events" onClick={handleCollapse}>
                      Event Gallery
                    </NavLink>
                  </li>
                  <li className="dropdown-item nav-sub-list-item">
                    <NavLink to="/life-at-mindox/careers" onClick={handleCollapse}>
                      Careers
                    </NavLink>
                  </li>
                </div>
              </ul>

            </li>
          </ul>

          <div className="px-0">
            <PrimaryButton label={"Contact us"} handleOnClick={"/contact-us"} />
          </div>
        </div>
      </div>
    </nav>
  );
};
export default NavigationBar;
